<app-section-banner [title]="'contact.title' | translate"
  [backgroundImage]="'assets/img/banner_contact.png' | imageConverter">
</app-section-banner>
<section class="relative w-full md:w-full lg:w-2/3 xl:w-2/3 lg:ml-12 xl:ml-36 md:ml-0 sm:ml-4">
  <div class="max-w-screen-xl mx-auto flex flex-col lg:flex-row 2xl:max-w-[1920px] 2xl:ml-24">
    <div class="relative md:relative lg:absolute w-full lg:w-1/2 bg-[#34384B] text-[#F2F4FE] p-8 md:p-12 lg:p-16 z-10">
      <h2 class="text-[#F2F4FE] text-left text-lg sm:text-base md:text-lg font-extralight mt-8 mb-6">{{
        'contact.get_in_touch_title' | translate }}</h2>
      <p class="text-xs font-light leading-6 mb-8">
        <span class="block">{{ 'contact.get_in_touch_1' | translate }}</span>
        <span class="block">{{ 'contact.get_in_touch_2' | translate }}</span>
        <span class="block">{{ 'contact.get_in_touch_3' | translate }}</span>
        <span class="block">{{ 'contact.get_in_touch_4' | translate }}</span>
      </p>

      <div class="space-y-16 mb-12">
        <div
          class="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 md:space-x-9">
          <picture>
            <source [srcset]="'assets/svg/contacto/location.svg' | imageConverter" type="image/svg+xml" />
            <img [src]="'assets/img/location.png' | imageConverter" alt="Direccion" width="40" height="40"
              class="w-6 md:w-8 lg:w-10" />
          </picture>
          <div>
            <h3 class="text-xs font-light text-[#CBD6FC] mb-1 md:mb-3">{{ 'contact.address' | translate }}</h3>
            <p class="text-xs font-extralight text-[#F2F4FE]">{{ 'contact.address_value' | translate }}</p>
          </div>
        </div>
        <div
          class="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 md:space-x-9">
          <picture>
            <img [src]="'assets/svg/contacto/phone.svg' | imageConverter" alt="Llamanos" width="40" height="40"
              class="w-6 md:w-8 lg:w-10" />
            <source [srcset]="'assets/img/phone.png' | imageConverter" />
          </picture>
          <div>
            <h3 class="text-xs font-light text-[#CBD6FC] mb-1 md:mb-3">{{ 'contact.call_us' | translate }}</h3>
            <p class="text-xs font-extralight text-[#F2F4FE]">
              <a [href]="'https://wa.me/56963472977'" target="_blank" rel="noopener noreferrer"
                aria-label="Contactanos por WhatsApp" class="hover:text-[#5173EF] transition-colors duration-300">
                +569 6347 2977
              </a>
            </p>
          </div>
        </div>
        <div
          class="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 md:space-x-9">
          <picture>
            <img [src]="'assets/svg/contacto/message.svg' | imageConverter" alt="Email" width="40" height="40"
              class="w-6 md:w-8 lg:w-10" />
            <source [srcset]="'assets/img/message.png' | imageConverter" />
          </picture>
          <div>
            <h3 class="text-xs font-light text-[#CBD6FC] mb-1 md:mb-3">{{ 'contact.email' | translate }}</h3>
            <p class="text-xs font-extralight text-[#F2F4FE]">{{ 'contact.email_value' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="w-full bg-[#5173EF] py-10">
  <div class="max-w-screen-xl mx-auto flex flex-col lg:flex-row">
    <div class="w-full lg:w-1/2 flex flex-col p-4 bg-[#5173EF] text-[#F2F4FE] lg:ml-auto lg:mt-0 ">
      <h2 class="text-[#F2F4FE] text-left text-xl sm:text-xl font-semibold tracking-wide mb-2 2xl:ml-16">
        {{ 'contact.cta' | translate }}</h2>
      <p class="text-sm sm:text-base font-extralight leading-6 2xl:ml-16 whitespace-normal 2xl:whitespace-nowrap">
        {{ 'contact.cta_description_part1' | translate }}<br class="hidden sm:block">
        {{ 'contact.cta_description_part2' | translate }}
      </p>
    </div>
  </div>
</section>

<section class="w-full bg-white py-4 ">
  <div class="max-w-screen-xl mx-auto px-4 ">
    <div class="w-full lg:w-1/2 lg:ml-auto ">
      <!-- Form -->
      <form *ngIf="!formSubmitted" [formGroup]="form" (ngSubmit)="onSubmit()"
        class="space-y-8 max-w-xl mt-8 xl:ml-2 2xl:ml-20">

        <!-- name -->
        <div class="relative">
          <input type="text" formControlName="name" placeholder="{{ 'contact.name.label' | translate }}"
            class="w-full p-3 border border-[#E3E3E3] rounded text-[#999999] placeholder:text-sm placeholder:tracking-wider focus:border-[#5173EF]" />
          <div *ngIf="name?.touched && name?.invalid" class="text-xs absolute left-0 mt-1 text-[#5173EF]">
            {{ name?.errors?.['required'] ? ('contact.name.required_error' | translate) :
            name?.errors?.['pattern'] ? ('contact.name.invalid_error' | translate) : '' }}
          </div>
        </div>

        <!-- email -->
        <div class="relative">
          <input type="email" formControlName="email" placeholder="{{ 'contact.email_fields.label' | translate }}"
            class="w-full p-3 border border-[#E3E3E3] rounded text-[#999999] placeholder:text-sm placeholder:tracking-wider focus:border-[#5173EF]" />
          <div *ngIf="email?.touched && email?.invalid" class="text-xs absolute left-0 mt-1 text-[#5173EF]">
            {{ email?.errors?.['required'] ? ('contact.email_fields.required_error' | translate) :
            email?.errors?.['email'] ? ('contact.email_fields.invalid_error' | translate) : '' }}
          </div>
        </div>

        <!-- mesagge -->
        <div class="flex flex-col relative">
          <textarea formControlName="message" placeholder="{{ 'contact.message.label' | translate }}"
            class="w-full p-3 border border-[#E3E3E3] rounded text-[#999999] placeholder:text-sm placeholder:tracking-wider focus:border-[#5173EF] resize-none"
            rows="4"></textarea>
          <div *ngIf="message?.touched && message?.invalid" class="text-xs text-[#5173EF] mt-1">
            {{ message?.errors?.['required'] ? ('contact.message.required_error' | translate) :
            message?.errors?.['maxlength'] ? ('contact.message.max_length_error' | translate) : '' }}
          </div>
          <div class="text-right text-xs text-[#999999] mt-1">
            {{ message?.value?.length || 0 }}/500
          </div>
        </div>

        <!--  submit button-->
        <button type="submit"
          class="w-full sm:w-auto bg-[#5173EF] text-[#F2F4FE] text-xs font-light tracking-wide py-3 px-6 rounded font-[Poppins] transition-all duration-300 ease-in-out transform hover:bg-white hover:text-[#34384B] hover:cursor-pointer focus:outline-none border-2 border-transparent active:border-[#5173EF] active:bg-white active:text-[#34384B]">
          {{ 'contact.submit_button' | translate }}
        </button>
      </form>
      <!-- formSubmitted is true -->
      <div *ngIf="formSubmitted"
        class="flex flex-col justify-center items-center w-full max-w-xl mx-auto py-20 sm:py-32 px-4 sm:px-8 border border-[#E3E3E3] rounded-lg h-auto mt-8 2xl:ml-20">
        <p class="text-normal text-[#020042] mb-8 text-center">
          {{ 'contact.thank_you_message' | translate }}
        </p>
        <button (click)="resetForm()"
          class="w-full sm:w-auto bg-[#5173EF] text-[#F2F4FE] text-xs font-light tracking-wide py-3 px-6 rounded font-[Poppins] transition-all duration-300 ease-in-out transform hover:bg-white hover:text-[#34384B] hover:cursor-pointer focus:outline-none border-2 border-transparent active:border-[#5173EF] active:bg-white active:text-[#34384B]">
          {{ 'contact.back_to_form_button' | translate }}
        </button>
      </div>
    </div>
  </div>
</section>

<section #newsletterSection class="relative flex flex-col lg:flex-row lg:mt-20">
  <app-newsletter class="relative w-full md:w-full lg:w-1/3 sm:ml-4 md:ml-0 lg:ml-12 xl:ml-36 2xl:ml-60">
  </app-newsletter>

  <div class="w-full lg:w-1/2 lg:ml-auto">
    <!-- Maps -->
    <div class="hidden md:hidden lg:flex relative w-full 2xl:ml-20
        lg:w-[48vw] lg:h-[71.3vh] lg:max-w-[562px] lg:max-h-[320px] 
        xl:w-[47vw] xl:h-[191vh] xl:max-w-[600px] xl:max-h-[320px] 
        2xl:w-[35.2vw] 2xl:h-[191vh] 2xl:max-w-[544px] 2xl:max-h-[320px]">
      <div class="w-full">
        <div *ngIf="mapReady" #mapContainer class="w-full h-[320px] rounded shadow-md">
        </div>
      </div>
    </div>
  </div>
</section>

<app-technologies></app-technologies>